import type { ApiClient } from './client';
import type { components } from './types.gen';

type DesignSummary = components['schemas']['DesignSummary'];

/**
 * Fetch EVERY design, following the server cursor. `GET /designs` caps a page at 100 and designs are
 * name-sorted, so a single-page fetch silently HIDES everything past the first 100 (A–Z) — a real
 * design then can't be seen in the library or picked when mapping a product. Both the design library
 * and the catalog mapping picker load the full set through this one helper, so neither can truncate.
 * The list is small at this scale; a searchable / virtualized picker is a separate later concern.
 */
export async function fetchAllDesigns(client: ApiClient): Promise<DesignSummary[]> {
  const all: DesignSummary[] = [];
  let cursor: string | undefined;
  do {
    const { data, error } = await client.GET('/designs', {
      params: { query: { limit: 100, cursor } },
    });
    if (error) throw new Error(error?.error?.detail ?? 'Failed to load designs.');
    if (!data?.ok) throw new Error('Empty response from the server.');
    all.push(...data.data.items);
    cursor = data.data.nextCursor ?? undefined;
  } while (cursor);
  return all;
}
